import React, { useCallback, useEffect, useRef, useState } from 'react';
import { FormText } from 'react-bootstrap';
import { useTranslate } from '@translations/useTranslate';
import VisitRequestOtpFormStyles from './VisitRequestOtpForm.module.scss';

const COUNT_DOWN_TIME = 120;

export interface ResendOtpMessageAndTimerProps {
  resendCode: (startTimer: () => void) => void;
  onTimerEnd?: () => void;
  onTimerStart?: () => void;
}
export const ResendOtpMessageAndTimer: React.FC<ResendOtpMessageAndTimerProps> = ({
  resendCode,
  onTimerEnd,
  onTimerStart,
}: ResendOtpMessageAndTimerProps) => {
  const { t } = useTranslate();

  const [counter, setCounter] = useState(COUNT_DOWN_TIME);
  const timeoutRef = useRef<ReturnType<typeof setTimeout>>();

  const startCountdown = useCallback(
    (count: number) => {
      onTimerStart?.();
      const tick = (current: number) => {
        if (current <= 0) {
          setCounter(0);
          onTimerEnd?.();
          return;
        }
        setCounter(current);
        timeoutRef.current = setTimeout(() => tick(current - 1), 1000);
      };
      tick(count);
    },
    [onTimerEnd, onTimerStart]
  );

  const convertSecondsToTime = (seconds: number) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    const formattedMinutes = String(minutes).padStart(2, '0');
    const formattedSeconds = String(remainingSeconds).padStart(2, '0');
    return `${formattedMinutes}:${formattedSeconds}`;
  };

  const handleOnResendCode = useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault();
      resendCode(() => {
        startCountdown(COUNT_DOWN_TIME);
      });
    },
    [resendCode, startCountdown]
  );

  useEffect(() => {
    startCountdown(COUNT_DOWN_TIME);
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
    // run once on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {counter === 0 ? (
        <FormText className={VisitRequestOtpFormStyles.resend_code}>
          {`${t('vr.form.didnt.get')}${' '}`}
          <a
            href={'#'}
            onClick={handleOnResendCode}
            className={VisitRequestOtpFormStyles.resend_code_linked}
          >
            {`${t('vr.form.resend.code')}`}
          </a>
        </FormText>
      ) : (
        <FormText className={VisitRequestOtpFormStyles.resend_code}>
          {`${t('vr.form.resend')}${' '}${convertSecondsToTime(counter)}`}
        </FormText>
      )}
    </>
  );
};
